import { useParams } from "react-router";
import { useRawData } from "./hooks/useRawData";
import AnalyticsModule from "./AnalyticsModule";
import ReflectionModule from "./ReflectionModule";
import SolutionModule from "./SolutionModule";

import "./styles.scss";

function IndividualPdfReport() {
  const { sessionId } = useParams<{ sessionId: string }>();
  const { data: rawData, isLoading } = useRawData(sessionId);
  const logoUrl = rawData?.client.logoUrl?.trim() || "/logo.png";

  const moduleProps = { rawData, sessionId, isLoading };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="pdf-report-page">
      <div className="page start-report-page">
        <div
          className="main-page-logo"
          style={{
            backgroundImage: `url(${logoUrl})`,
          }}
        />
        <div className="logo" />
      </div>

      <AnalyticsModule {...moduleProps} />
      <ReflectionModule {...moduleProps} />
      <SolutionModule {...moduleProps} />
    </div>
  );
}

export default IndividualPdfReport;
// http://localhost:3000/futurebility-cockpit-individual-report/a216f312-20ab-498b-a0e1-936ee2925f89
